import React from "react";
import RadioButtonComponent from "../Buttons/RadioButton";
import _ from "lodash";
import { Box, Typography } from "@mui/material";
import { getAnswerLabel } from "../../molecule/Forms/quizAdmin/AdminQuestions";


export default ({ answers = [], correctAnswers = [] }) => {  
    return (
        <Box>
            <Box mb={2}>
                {answers.map((ans, index) => (
                    <Box sx={{ display: "flex", alignItems: "center", height: "auto" }} key={ans.id}>
                        <Box>
                            <RadioButtonComponent
                                checked={_.get(ans, 'is_correct', 0) == 1}
                            />
                        </Box>
                        <Box>
                            <p style={{ fontFamily: "Montserrat, sans serif", fontSize: "100%", padding: 0, margin: 0 }}>
                                {getAnswerLabel(index)} {_.get(ans, 'answer', '')}
                            </p>
                        </Box>
                    </Box>
                ))}
            </Box>

            <Typography
                variant="subtitle2"
                color="#28b882"
                fontWeight={700}
                mb={1}
            >
                Correct Answer:
            </Typography>

            <Box mb={2}>
                {correctAnswers.map((ans) => (
                    <Box sx={{ display: "flex", alignItems: "center", height: "auto" }} key={ans.id}>
                        <Box>
                            <p style={{ fontFamily: "Montserrat, sans serif", fontSize: "100%", padding: 0, margin: 0, fontWeight: 700 }}>
                                {getAnswerLabel(ans.id - 1)} {_.get(ans, 'answer', '')}
                            </p>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}